exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@page{size:landscape}div>div>div>div.el-card__body>div.mt-5>div{width:100%!important}", ""]);

// exports
